import { SettingsNames } from './settings-links-map'
import { labelIncludesSettingsSearch } from './settings-search'

type DeepSearchCatalogEntry = {
  parent: SettingsNames
  /** Если не задано — совпадение по ключевым словам показывает весь блок (все видимые подвкладки). */
  subLinkName?: string
  keywords: readonly string[]
}

/**
 * Узкий ручной индекс для поиска по смыслу (синонимы и формулировки вне заголовков меню).
 * При добавлении пунктов — держите ключевые слова в нижнем регистре.
 */
const SETTINGS_DEEP_SEARCH_CATALOG: DeepSearchCatalogEntry[] = [
  {
    parent: SettingsNames.account,
    keywords: ['данные', 'электронная почта', 'почта', 'email', 'info'],
  },
  {
    parent: SettingsNames.confidentiality,
    subLinkName: 'pinPasswordInput',
    keywords: ['смена пароля', 'пароль', 'change password', 'password'],
  },
  {
    parent: SettingsNames.confidentiality,
    keywords: ['disa', 'диса'],
  },
  {
    parent: SettingsNames.soundAndVideo,
    keywords: [
      'доступ', 'access',
      'разрешение', 'permission',
      'разрешения', 'permissions',
      'камера', 'camera',
      'микрофон', 'microphone',
      'веб камера', 'web camera',
      'режим рации', 'radio mode',
      'рация', 'radio',
      'качество видео', 'video quality',
      'разрешение видео', 'video resolution',
      '720p', '1080p',
      'шаринг', 'демонстрация экрана', 'screen share',
      'отлад', 'debug',
      'динамики', 'speakers',
      'динамик', 'speaker',
      'спикер', 'speaker',
    ],
  },
  {
    parent: SettingsNames.calls,
    subLinkName: 'incomingCallHandling',
    keywords: ['переадресация', 'переадрессация', 'не беспокоить', 'вмешательство в разговор', 'вмешательство', 'interruption', 'interruption in conversation', 'forwarding', 'forward', 'do not disturb', 'dnd'],
  },
  {
    parent: SettingsNames.terminals,
    subLinkName: 'terminalsList',
    keywords: ['текущие сессии', 'сессии', 'сессия', 'current sessions', 'sessions', 'session'],
  },
  {
    parent: SettingsNames.notifications,
    subLinkName: 'notificationSettings',
    keywords: ['не беспокоить', 'dnd', 'do not disturb', 'dnd'],
  },
  {
    parent: SettingsNames.interface,
    subLinkName: 'aSideMenuSettings',
    keywords: [
      'реакция', 'быстрая реакция', 'reaction', 'quick reaction',
      'тема', 'тёмная', 'темная', 'dark', 'theme', 'светлая', 'системная',
    ],
  },
  {
    parent: SettingsNames.interface,
    subLinkName: 'themeSettings',
    keywords: ['тема', 'тёмная', 'темная', 'dark', 'theme', 'светлая', 'системная'],
  },
  {
    parent: SettingsNames.interface,
    subLinkName: 'chatSettings',
    keywords: [
      'чат',
      'ширина чата',
      'ширина сообщений',
      'настройка чата',
      'chat',
      'chat width',
      'messages width',
      'chat settings',
    ],
  },
]

const entryMatchesQuery = (keywords: readonly string[], normalizedQuery: string): boolean =>
  keywords.some((kw) => labelIncludesSettingsSearch(kw, normalizedQuery))

export const matchesDeepSearchForParent = (parent: SettingsNames, normalizedQuery: string): boolean => {
  if (!normalizedQuery) return false
  return SETTINGS_DEEP_SEARCH_CATALOG.some(
    (entry) =>
      entry.parent === parent
      && entry.subLinkName === undefined
      && entryMatchesQuery(entry.keywords, normalizedQuery),
  )
}

export const matchesDeepSearchForSublink = (
  parent: SettingsNames,
  subLinkName: string,
  normalizedQuery: string,
): boolean => {
  if (!normalizedQuery) return false
  return SETTINGS_DEEP_SEARCH_CATALOG.some(
    (entry) =>
      entry.parent === parent
      && entry.subLinkName === subLinkName
      && entryMatchesQuery(entry.keywords, normalizedQuery),
  )
}
